import { render, staticRenderFns } from "./ksef.details.modal.vue?vue&type=template&id=ecac1b80&scoped=true&"
import script from "./ksef.details.modal.vue?vue&type=script&lang=js&"
export * from "./ksef.details.modal.vue?vue&type=script&lang=js&"
import style0 from "./ksef.details.modal.vue?vue&type=style&index=0&id=ecac1b80&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecac1b80",
  null
  
)

export default component.exports